<div class="modal-header">
  <h2>Re-create email templates</h2>
  <button
    type="button"
    class="close"
    aria-label="Close"
    (click)="activeModal.dismiss('Cross click')"
  >
    <span aria-hidden="true">&times;</span>
  </button>
</div>
<div class="modal-body">
  <div *ngIf="allAccounts; else byAccountRef">
    <p>Are you sure you want to re-create email templates on ALL accounts?</p>
    <p class="warning">
      <i class="fa fa-exclamation-triangle"></i> This process affects ALL
      customers and should be used with extreme caution.
    </p>
  </div>

  <ng-template #byAccountRef>
    <div class="form-group">
      <div class="d-flex justify-content-between align-items-center">
        <label for="from-account">On account *</label>
        <input
          placeholder="Filter accounts"
          type="text"
          class="form-control form-control-sm filter-input"
          (change)="filter = $event.target.value"
        />
      </div>
      <select class="form-control" id="account" [formControl]="account">
        <option value="" selected="selected">Choose account</option>
        <option *ngFor="let account of filteredAccounts" [value]="account.id">
          {{ account.displayName }} ({{ account.id }})
        </option>
      </select>
    </div>
  </ng-template>
</div>
<div class="modal-footer">
  <button
    type="button"
    class="btn btn-outline-dark"
    (click)="activeModal.close('Close click')"
  >
    Cancel
  </button>
  <button
    type="button"
    class="btn btn-success"
    [disabled]="account.invalid && !allAccounts"
    (click)="onSubmit()"
  >
    <i class="fas fa-history"></i> Re-create email templates
  </button>
</div>
